import styled from "styled-components";

export const Container = styled.section`
  background: #fff;
  border-radius: 16px;
  margin: 0 16px;
  padding: 20px 16px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 12px;
`;

export const Title = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #4a4a4a;
  margin-right: 4px;
`;

export const Icon = styled.img`
  width: 32px;
  height: 24px;
  object-fit: contain;
  border-radius: 4px;
`;

export const Description = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #4a4a4a;
  line-height: 1.4;
`;

